/* eslint-disable */
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface OrderCancelApiParameter extends ApiParameter {
    orderNumber: string;
}

const orderCancelUrl = "api/v1/OrderCancel";

export type OrderCancelResult = {
    orderNumber: string;
    cancelled: boolean;
};

// eslint-disable-next-line require-await
export async function callCancelOrderWithResult(parameter: string): Promise<ServiceResult<string>> {
    return get<any>(`${orderCancelUrl}/CancelOrder?orderNumber=${parameter}`, {} as ApiParameter);
}
